module.exports = {
  all_videos: [
    {
      id: 1,
      url: 'https://www.youtube.com/embed/rCN4auGW4X4',
      title: 'Stripe Connect Express   How it works?',
      description: '',
      watch_time: '16 min',
      lavel: 'Basic',
      type: 'Others',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/1MqAI7ZVygY',
      title: 'Stripe connect EXPRESS* onboarding demo',
      description: '',
      watch_time: '2 min',
      lavel: 'Basic',
      type: 'Others',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/wuUd-qmkXDk',
      title: 'What is Platform Economy Business Model and where the future economy is moving?',
      description: '',
      watch_time: '9 min',
      lavel: 'Basic',
      type: 'Others',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/gPy3TRB88rY',
      title:
        'How Stripe Connect Fee Works for Marketplace and Platform business like delivery platform',
      description: '',
      watch_time: '5 min',
      lavel: 'Basic',
      type: 'Others',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/o5kUCaNvRus',
      title:
        'How to use Firebase App Distribution to TEST APP for pre release / internal company distribution',
      description: '',
      watch_time: '2 min',
      lavel: 'Basic',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/t0BgCoX-SUI',
      title: 'How to Start and Launch a Sneaker Reselling Marketplace',
      description: '',
      watch_time: '32 min',
      lavel: 'Intermediate',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/EIdYmf9xhFs',
      title: 'Seller Journey (Supply Side Journey for a marketplace)',
      description: '',
      watch_time: '7 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/HzTNKhxQD4g',
      title: 'Setting up Listings - Building a marketplace',
      description: '',
      watch_time: '19 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/qF0orL-b2QM',
      title: 'TradlyPlatform Demo - Headless Solution and Full Package offering',
      description: '',
      watch_time: '14 min',
      lavel: 'Basic',
      type: 'Others',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/mgGm3kWiaos',
      title: 'App look customisation',
      description: '',
      watch_time: '1 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/d60g6nT42vg',
      title: 'Buyer Journey - Demand Side journey in the marketplace',
      description: '',
      watch_time: '5 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/ZyXP4BoVZr4',
      title: 'Configuring Firebase for push notifications, chat.',
      description: '',
      watch_time: '12 min',
      lavel: 'Advanced',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/BQdBxFRx6oQ',
      title: 'Customising the app branding and assets - Build a marketplace',
      description: '',
      watch_time: '23 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/qQvifSE3HPU',
      title: 'Force Update Features',
      description: '',
      watch_time: '1 min',
      lavel: 'Intermediate',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/-gh7vyTtWU8',
      title: 'How Tradly works? The architecture and configuration in a Nutshell',
      description: '',
      watch_time: '8 min',
      lavel: 'Intermediate',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/6bOOzd9UagI',
      title: 'How to Build a B2B Platform for Agriculture - Products, Seeds, Produce',
      description: '',
      watch_time: '15 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/ydvDY4BLYBY',
      title: 'How to build Pre loved luxury watch business - Marketplace / B2C website & App',
      description: '',
      watch_time: '22 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/TAaEknMCemQ',
      title: 'How to configure Branch Metrics in Tradly SuperAdmin & benefits',
      description: '',
      watch_time: '8 min',
      lavel: 'Intermediate',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/WbUyuNMuGo0',
      title: 'How to deploy web app to Vercel?',
      description: '',
      watch_time: '7 min',
      lavel: 'Intermediate',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/albCW1l5Xnk',
      title: 'How to use competitor Search Keywords to plan your content theme -  SEO',
      description: '',
      watch_time: '3 min',
      lavel: 'Intermediate',
      type: 'Marketing',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/_NybkZ3VcO4',
      title: '1 Creating Identifier',
      description: '',
      watch_time: '1 min',
      lavel: 'Advanced',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/02Ebpz_XgF8',
      title: '2 Creating CSR',
      description: '',
      watch_time: '0 min',
      lavel: 'Advanced',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/2fZsCbOxBTo',
      title: '3 Create Certificate',
      description: '',
      watch_time: '1 min',
      lavel: 'Advanced',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/DAka6fbanIs',
      title: '4 Create Profile',
      description: '',
      watch_time: '0 min',
      lavel: 'Advanced',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/xozP1Pmok3U',
      title: 'Approval and Rejection - Accounts & Listings',
      description: '',
      watch_time: '1 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/zyVf4t5U_GE',
      title: 'Configuring Revenue Model and shipping Method - Building a marketplace',
      description: '',
      watch_time: '15 min',
      lavel: 'Intermediate',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/s5miuwJRR-I',
      title: 'Configuring Stripe Payments & Payout - Build a marketplace',
      description: '',
      watch_time: '12 min',
      lavel: 'Advanced',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/iRIefU4jZ4k',
      title: 'Creating a new app in Appstore Developer Account',
      description: '',
      watch_time: '9 min',
      lavel: 'Advanced',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/bErplKtm0yo',
      title: 'DNS verification with AWS  SES for whitelabel Email sending',
      description: '',
      watch_time: '5 min',
      lavel: 'Intermediate',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/G6efOFbjV9E',
      title: 'Govt City Council Software -  Encouraging Recycle Activities',
      description: '',
      watch_time: '3 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/5y_dG5SZCsg',
      title: 'Home Page - Catalogue - Promo Banners -  Collection Widget',
      description: '',
      watch_time: '2 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/BNzXxmJ_gkk',
      title: 'Homepage Customisation - Part 1',
      description: '',
      watch_time: '0 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/3FCvI6vBfSw',
      title: 'Homepage Customisation - Part 2',
      description: '',
      watch_time: '1 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/m3770W-tme0',
      title: 'How to Change the Support URL - Terms  - FAQ  - Privacy URL',
      description: '',
      watch_time: '4 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/MYmICW87OZM',
      title: 'How to UPDATE latest version in Google Playstore',
      description: '',
      watch_time: '7 min',
      lavel: 'Intermediate',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/OBC3mJcn12E',
      title: 'How to change Branch.io referral links with a Custom Domain (DNS)',
      description: '',
      watch_time: '4 min',
      lavel: 'Intermediate',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/e7y3xTgs2U8',
      title: 'How to create Facebook Analytics App and the Benefits',
      description: '',
      watch_time: '4 min',
      lavel: 'Intermediate',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/PnYi4eYup4I',
      title:
        'How to create Facebook Custom Audience and Lookalike audience to retarget your mobile app users',
      description: '',
      watch_time: '3 min',
      lavel: 'Intermediate',
      type: 'Marketing',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/rGusFO9_Ias',
      title: 'How to setup Google Playconsole for app release',
      description: '',
      watch_time: '7 min',
      lavel: 'Intermediate',
      type: 'Integrations',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/xXnZCIdOMQ8',
      title: 'How to use Firebase to send push notification : Cloud messaging',
      description: '',
      watch_time: '2 min',
      lavel: 'Intermediate',
      type: 'Marketing',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/RgVgan8bmkk',
      title: 'How to use new SuperAdmin Panel - V2',
      description: '',
      watch_time: '10 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/S9SfaKjzhmc',
      title: 'Introducing Single Click Deployment of Web Apps with Vercel Integrations',
      description: '',
      watch_time: '3 min',
      lavel: 'Basic',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/ALQwwL4U-AU',
      title: 'Launching ReactJs (CRA) app in Netlify - Hummingbirds',
      description: '',
      watch_time: '8 min',
      lavel: 'Intermediate',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/9iRtSBkOj-w',
      title: 'Multi Languages',
      description: '',
      watch_time: '2 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/umdYJUCB-zM',
      title: 'Onboarding Screens Customisation',
      description: '',
      watch_time: '1 min',
      lavel: 'Basic',
      type: 'Features Demo',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/dB_fTunI2Ac',
      title: 'Releasing new build on the appstore',
      description: '',
      watch_time: '3 min',
      lavel: 'Intermediate',
      type: 'Deployment',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/T1sN1C9qUSI',
      title: 'Setting up Accounts - Building a marketplace',
      description: '',
      watch_time: '16 min',
      lavel: 'Basic',
      type: 'Building Series',
    },

    {
      id: 1,
      url: 'https://www.youtube.com/embed/-e0CYw5kyMU',
      title: 'Technical Logs',
      description: '',
      watch_time: '1 min',
      lavel: 'Intermediate',
      type: 'Features Demo',
    },
  ],
}
